<nz-time-picker [nzAutoFocus]='nzAutoFocus' [nzDisabled]='nzDisabled' [nzSize]='nzSize' [nzFormat]='nzFormat'
                [nzAddOn]='nzAddOn' [nzDisabledHours]='nzDisabledHours' [nzDisabledMinutes]='nzDisabledMinutes'
                [nzDefaultOpenValue]='nzDefaultOpenValue' [nzDisabledSeconds]='nzDisabledSeconds'
                [nzHideDisabledOptions]='nzHideDisabledOptions' [nzHourStep]='nzHourStep' [nzMinuteStep]='nzMinuteStep'
                [nzSecondStep]='nzSecondStep' [nzOpen]='nzOpen' [nzPopupClassName]='nzPopupClassName'
                [nzUse12Hours]='nzUse12Hours'
                [nzPlaceHolder]='nzPlaceHolder' [(ngModel)]='value'
                (ngModelChange)='onNgModelChangeChange($event)'
                (nzOpenChange)='onNzOnOpenChange($event)'>
</nz-time-picker>
